import { call, put, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash';
import refundService from '../services/RefundService';
import {
    RefundActionTypes,
    refundActions,
} from '../store/slices/refundSlice';

// saga handler to fetch Cancellation sectionwise and update redux store as per the api payload
export const fetchRefundSection = function* (action) {
    try {
        const response = yield call(
            refundService.getRefundSection,
            action.payload
        );
        const responseData = yield get(response, 'data');


        yield put(
            refundActions.setRefundSection({
                sectionName: 'SectionData',
                data: responseData,
            })
        );
    } catch (err) {
        const errorMessage = err?.response?.data?.message || err.message;
        console.error(errorMessage);
    }
};

export default function* refundSaga() {
    yield takeLatest(RefundActionTypes.FETCH_REFUND, fetchRefundSection);
}
